import { Component, OnInit } from '@angular/core';
import { UtilsService } from 'src/app/shared/utils.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-screen-title',
    templateUrl: './screen-title.component.html',
    styleUrls: ['./screen-title.component.scss'],
    standalone: false
})
export class ScreenTitleComponent implements OnInit {
  title: any;
  firstTitle: any;
  secondTitle: any;
  thirdTitle: any;
  firstRoute: any;
  secondRoute: any;
  thirdRoute: any;

  constructor(private utils: UtilsService, private router: Router) { }

  ngOnInit(): void {
    this.utils.screenTitle.subscribe((titles: any) => {
      this.firstTitle = titles.firstTitle;
      this.secondTitle = titles.secondTitle;
      this.thirdTitle = titles.thirdTitle;
      this.firstRoute = titles.firstRoute;
      this.secondRoute = titles.secondRoute;
      this.thirdRoute = titles.thirdRoute;
    });
  }

  goTo(titleLevel: any) {
    if (titleLevel === 1) {
      this.router.navigate([this.firstRoute]);
    } else if (titleLevel === 2) {
      this.router.navigate([this.secondRoute]);
    } else if (titleLevel === 3) {
      this.router.navigate([this.thirdRoute]);
    }
  }
}
